module.exports = __webpack_public_path__ + "img/img26.b1e13693.svg";